import { CreatorsToActions } from '../helper'

type Actions = CreatorsToActions<typeof import('../actions/auth')>

interface State {
  id: number
  token: string
  adminId: string
  password: string
  name: string
}
// ______________________________________________________
//
export function initialState(injects?: State): State {
  return {
    id: 0,
    token: '',
    adminId: '',
    password: '',
    name: ''
  }
}
// ______________________________________________________
//
export function reducer(state = initialState(), action: Actions): State {
  switch (action.type) {
    case 'SET_AUTH':
      return {
        id: action.payload.id,
        token: action.payload.token,
        adminId: action.payload.adminId,
        password: action.payload.password,
        name: action.payload.name
      }
    case 'UNSET_AUTH':
      return { id: 0, token: '', adminId: '', password: '', name: '' }
    default:
      return state
  }
}
